import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/utils/cn'
import {
  shellInsetCardClassName,
  shellPageBackgroundClassName,
  shellMutedPanelClassName,
  shellPageContentClassName,
  shellSurfaceClassName,
} from '@/components/shell/ShellChrome'

export const buildPageShellClassName =
  `relative h-full overflow-y-auto ${shellPageBackgroundClassName}`

export const buildPageContentClassName = shellPageContentClassName

export const buildPageContentWithMobileBarClassName = `${buildPageContentClassName} pb-28 lg:pb-8`

export const buildSurfaceClassName = shellSurfaceClassName

export const buildSectionCardClassName =
  'rounded-card border border-border bg-card p-6'

export const buildSoftSectionCardClassName =
  'rounded-card border border-border bg-card p-5'

export const buildInsetCardClassName = shellInsetCardClassName

export const buildMutedPanelClassName = shellMutedPanelClassName

export function BuildPageFrame({
  children,
  className,
  mobileBarPadding = false,
}: {
  children: ReactNode
  className?: string
  mobileBarPadding?: boolean
}) {
  return (
    <div className={cn(buildPageShellClassName, className)}>
      <div
        className={cn(
          mobileBarPadding ? buildPageContentWithMobileBarClassName : buildPageContentClassName,
        )}
      >
        {children}
      </div>
    </div>
  )
}

export function BuildSurface({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLElement>) {
  return (
    <section className={cn(buildSurfaceClassName, className)} {...props}>
      {children}
    </section>
  )
}


export function BuildSectionCard({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLElement>) {
  return (
    <section className={cn(buildSectionCardClassName, className)} {...props}>
      {children}
    </section>
  )
}

export function BuildInsetCard({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(buildInsetCardClassName, className)} {...props}>
      {children}
    </div>
  )
}

